import { render, staticRenderFns } from "./RiderPwdQuery.vue?vue&type=template&id=0b4cd672&scoped=true"
import script from "./RiderPwdQuery.vue?vue&type=script&lang=js"
export * from "./RiderPwdQuery.vue?vue&type=script&lang=js"
import style0 from "./RiderPwdQuery.vue?vue&type=style&index=0&id=0b4cd672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4cd672",
  null
  
)

export default component.exports